// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"dropzone_dropzone__2IT59"};